class Controller {
  constructor(Route, $mdDialog, schedule, routeId) {
    "ngInject";

    this.schedule = schedule;
    this.$mdDialog = $mdDialog;
    this.pickup = null;
    this.dropoff = null;
    this.invalidPickup = null;
    this.invalidDropoff = null;
    Route.get(routeId).$promise.then((response) => {
      this.stations = response.stations;
    });
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    if (this.user && this.pickup && this.dropoff) {
      const options = {};
      options.pick_up = this.pickup;
      options.drop_off = this.dropoff;
      options.user = this.user._id;

      this.$mdDialog.hide(options);
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/actionListTable/addSubscriptionDialog/addSubscriptionDialog.controller.js